import { useEffect, useState } from "react"

import { Flex, Tooltip, Typography } from "antd"
import cls from "classname"

import Icon from "../../../../Icon"

import "./ApiKeyField.less"

const { Text } = Typography

const ApiKeyField = ({ value, className, hidden, setHidden }) => {
  const [copied, setCopied] = useState(false)
  const visibleText = hidden ? "•".repeat(value.length) : value
  useEffect(() => {}, [])

  const disableCopy = (e) => {
    e.preventDefault()
  }

  const copyApiKey = () => {
    setCopied(true)
    navigator.clipboard.writeText(value)
  }
  return (
    <Flex gap={12} className={cls("api-key-field", className)} align="center">
      <Text className="api-key-text" onCopy={hidden ? disableCopy : null}>
        {visibleText}
      </Text>
      <button className="icon-btn" onClick={() => setHidden((prev) => !prev)}>
        {hidden ? (
          <Icon className="eye-icon" type="eye" />
        ) : (
          <Icon className="eye-icon-invisible" type="eye_invisible" />
        )}
      </button>
      <Tooltip title={copied ? "Copied" : "Copy"}>
        <button className="icon-btn" onClick={copyApiKey}>
          <Icon className="copy-icon" type="copy" />
        </button>
      </Tooltip>
    </Flex>
  )
}

export default ApiKeyField
